import langData from './languages/langs.json'
export const defaultLocale = 'cz'
export const languages = {
  sk: langData.sk,
  cz: langData.cz,
  en: langData.en
}